import { render, staticRenderFns } from "./UcContractServices.yaml?vue&type=template&id=74d42681&component"
import script from "./UcContractServices.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractServices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports